export default __webpack_public_path__ + "static/media/const5.dbd18aae.jpg";